<template>
  <div class="contactUsContainer">
    <div class="topTitleContainer">
      <div class="contactTitle">Get in touch</div>
      <div class="titleContent">Our team is dedicated to answering your inquiries</div>
    </div>
    <div class="contactUsContent" v-if="subPageFlag==0">
      <div class="salesType typeBox">
        <div class="salesContent typeContentBox">Contact Sales</div>
        <el-button :plain="true" @click="changeSubPageFlag(1)" >Contact Sales</el-button>
      </div>
      <div class="feedbackType typeBox">
        <div class="feedbackContent typeContentBox">Feedback</div>
        <el-button :plain="true" @click="changeSubPageFlag(2)" >Submit a Ticket</el-button>
      </div>
      <div class="joinType typeBox">
        <div class="joinContent typeContentBox">代理商</div>
        <el-button :plain="true" @click="changeSubPageFlag(3)" >Join Us</el-button>
      </div>
    </div>
    <div class="contactUsAdvice" v-if="subPageFlag==1">
      <el-form label-width="215px" class="demo-ruleForm">
        <el-form-item label="Name">
          <el-input v-model="ruleForm.firstname"></el-input>
          <el-input v-model="ruleForm.lastname"></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="Region" >
          <el-select v-model="ruleForm.country" size="small">
              <el-option v-for="(item,index) in regions.country" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="I am a" >
          <el-select v-model="ruleForm.country" size="small">
              <el-option v-for="(item,index) in regions.country" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
          </el-select>
        </el-form-item>
        <hr>
        <el-form-item label="Subject">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="Inquiry">
          <el-input type="textarea" v-model="ruleForm.email"></el-input>
        </el-form-item>

      </el-form>
    </div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
import region from '@/components/region';
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
      subPageFlag:0,
      ruleForm:{},
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    regions() {
      return region;
    },
  },
  methods: {
    changeSubPageFlag(val){
      this.subPageFlag = val;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.contactUsContainer{
    padding: 0;
    margin-top:40px;
    text-align:center;
    padding-bottom:80px;
}
.contactUsContainer .topTitleContainer{
  height:268px;
  padding-top:106px;
}
.contactUsContainer .topTitleContainer .contactTitle{
  height:59px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 59px;
  color: #000000;
}

.contactUsContainer .topTitleContainer .titleContent{
  height: 77px;
  margin-top:26px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 32px;

  color: #000000;
}
.contactUsContainer .contactUsContent{
  padding-top:91px;
}
.contactUsContainer .contactUsContent .typeBox{
  width: 379px;
  height:536px;
  display:inline-block;
}
.contactUsContainer .contactUsContent .feedbackType{
  margin-left:73px;
  margin-right:73px;
}
.contactUsContainer .contactUsContent .typeContentBox{
  width: 379px;
  background: #C4C4C4;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 59px;
  text-align: center;
  height:409px;
  line-height: 409px;
}
.contactUsContainer .contactUsContent .typeBox .el-button{
  width: 242px;
  height: 63px;
  background: #222222;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 27px;
  color: #FFFFFF;
  margin:0 auto;
  margin-top:68px;
}
.contactUsContainer .contactUsContent .typeBox .el-button:hover{
  opacity:0.9;
  border-color:#000;
  color:#fff;
}

.contactUsContainer .contactUsAdvice{
  margin-top:43px;
  margin-left:calc( 50% - 412px);
  width: 824px;
  height: 911px;

  background: #FFFFFF;

  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
}
</style>




// WEBPACK FOOTER //
// src/components/ContactUs.vue